import { Component, OnInit, Input } from '@angular/core';
import { SessionService } from '@app/store/session/session.service';
import { UserInfo } from '@app/store/session/session.store';
import { Vehicle } from 'src/app/shared/model/vehicle';
import { DealerService, BidStatus } from 'src/app/shared/services/dealer.service';
import { GaEventsService } from 'src/app/shared/services/ga-events.service';
import { OpenService } from 'src/app/shared/services/open.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-exclusive-group-request',
  templateUrl: './exclusive-group-request.component.html',
  styleUrls: ['./exclusive-group-request.component.scss']
})
export class ExclusiveGroupRequestComponent implements OnInit {
  @Input() vehicle: Vehicle;
  @Input() isFastQuote: boolean;
  @Input() isListCard: boolean;

  loading = false;
  bidErrorMessage: string;
  showLatePaymentLink = false;
  latePaymentQueryParams = { expandedStatuses: '["SOLD_NO_PAYMENT"]' };
  bidValue: number;
  showModal = false;
  user: UserInfo;
  btnLabel: string = 'QUERO FAZER PARTE';
  showRequestBtn: boolean = true;
  info: {
    title: string;
    text: string;
  }

  constructor(
    private dealerService: DealerService,
    private eventsService: GaEventsService,
    private openService: OpenService,
    private sessionService: SessionService) { }

  ngOnInit() {
    this.bidValue = this.vehicle.currentPrice;
    this.sessionService.getUser().subscribe(u => this.user = u);
    this.checkGroupStatus();
  }

  checkGroupStatus() {
    this.info = {
      title: 'DISPONÍVEL PARA GRUPO EXCLUSIVO',
      text: 'Para você poder fazer uma oferta ou adquirir pelo valor de compra é preciso solicitar a entrada no grupo.'
    }
    if (this.vehicle.pendingExclusiveDealer) {
      this.info = {
        title: 'DISPONÍVEL PARA GRUPO EXCLUSIVO',
        text: 'Sua solicitação para entrar no grupo exclusivo já foi enviada e está sendo analisada pelo vendedor. Você receberá uma notificação por e-mail com a resposta da solicitação.'
      }
      this.btnLabel = 'SOLICITAÇÃO JÁ ENVIADA';
    }
  }

  requestJoinGroup() {
    if (this.vehicle.pendingExclusiveDealer)
      return;
    if (this.isFastQuote) {
      this.dealerService.requestJoinExclusiveGroupFastQuote(this.vehicle.id).subscribe(response => {
        this.showRequestBtn = false;
      });
    } else {
      this.dealerService.requestJoinExclusiveGroup(this.vehicle.id).subscribe(response => {
        this.showRequestBtn = false;
      });
    }
    this.info = {
      title: 'SOLICITAÇÃO ENVIADA COM SUCESSO!',
      text: 'Em breve você receberá o contato por e-mail do vendedor com a confirmação'
    }
  }

  openModal(): void {
    this.showModal = true;
  }

  closeModal(): void {
    this.showModal = false;
  }

}
